import React from "react";

import styled from "styled-components/macro";

import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import CheckboxSettingSection from "Signups/FamilyRegistration/Shared/CheckboxSettingSection";
import useFamilyRegistrationAdminPermissions from "Signups/FamilyRegistration/Shared/useFamilyRegistrationAdminPermissions";

export default function ReceiveGivingEnvelopes() {
  const { state } = useFamilyRegistrationContext();
  const { shouldDisableFamilyRegistrationSettings } =
    useFamilyRegistrationAdminPermissions();

  const receiveGivingEnvelopes =
    state?.familyRegistrationSettings?.receiveGivingEnvelopes;
  const groupName = receiveGivingEnvelopes?.groupName;
  const networkName =
    state?.familyRegistrationSettings?.networkFamilyRegistration?.networkName;
  const groupNameToDisplay = networkName === groupName ? "Everyone" : groupName;

  return (
    <div>
      <CheckboxSettingSection
        setting="receiveGivingEnvelopes"
        label="Ask members if they would like to receive giving envelopes"
        disabled={shouldDisableFamilyRegistrationSettings}
      >
        <Explainer>
          Members that request giving envelopes will be added to{" "}
          <a
            href={`${receiveGivingEnvelopes?.url}`}
            target="_blank"
            rel="noreferrer"
          >
            this report
          </a>{" "}
          on the {groupNameToDisplay} group.
        </Explainer>
      </CheckboxSettingSection>
    </div>
  );
}

const Explainer = styled.div`
  font-size: 0.9rem;
  color: #15436ab3;

  a {
    color: var(--fnBlue) !important;
  }
`;
